module.exports = "<div>\n  {{vm.file.abstract}}\n</div>\n";